import React from 'react'
import { selectCurrentUser } from "@/store/slices/authSlice";
import { useSelector } from "react-redux";
import Chip from '@mui/material/Chip';

//api
import { AxiosRequestConfig, AxiosResponse } from "axios";

import { getFoliosById } from '@/apis/invoices';



const UserCredits = (): any => {

  // const payload: any = {
  //   customer_id: user.id,
  // }
  // const paysByUserList = getFoliosById(payload);
  // current user logged
  const user: any = useSelector(selectCurrentUser);

  return (
    <>
      <Chip
        avatar={<img alt="" src="/static/images/topbar/credits.svg" />}
        label={`${user?.creditos_disponibles || 'N/D'}`}
        variant="outlined"
        size="medium"
        sx={
          {
            p: 1,
            border: 'none',
            fontWeight: 'bold',
          }
        }
      />
    </>
  )
}

UserCredits.propTypes = {}

export default UserCredits